var touch = false, clickEv = 'click', checkDropdown = [], checkSideMenu = [], checks_scroll = 0;  ;
var vendor=[];
var type=[];
var price_range=[];
var product_data=[];
var query='';
var total_pages = 1;
var current_page = 1;
var per_page_count=12;
var skeleton_html=`<div class="product-item col-sm-3 ">
<div class="product" style="background:#ffffff;">
<div class="row-left" style="padding-top:10px">
			<skeleton type="image" width="95%" height="150px" element-style="dark"></skeleton>
		</div>
		<div class="row-right animMix">
			<div class="grid-mode">
				<div class="rating-star">
					<span class="shopify-product-reviews-badge" data-id="4315078754403"></span>
				</div>
				<div class="product-title">
					<skeleton type="heading" element-style="dark"></skeleton>
				</div>
				<div class="product-price">
					<skeleton type="line" element-style="dark"></skeleton>
				</div>
			</div>
		</div>
	</div>
</div>`;

function getFilterProducts(page,reload){
  if(reload!==true){
    buildFilteredProducts(product_data,page,false);
  } else {
  if(vendor.length>0){
    for(i=0;i<vendor.length;i++){
      if(i==0){
        query ='vendor:'+vendor[i]; 
      } else {
        query +=' OR '+vendor[i];
      }
    }
  }
  
  if(type.length>0){
    for(i=0;i<type.length;i++){
      if(i==0){
        if(query!=''){
        	query +=' AND product_type:'+type[i]; 
        } else {
          	query ='product_type:'+type[i];
        }
      } else {
        query +=' OR '+type[i];
      }
    }
  }
  
  if(price_range['lower_limit']!='' && price_range['lower_limit']!=undefined){
    if(query!=''){
      query +=' AND variants.price:>='+ price_range['lower_limit'];
    } else {
      query =' variants.price:>='+ price_range['lower_limit'];
    }
  }
  
  if(price_range['upper_limit']!='' && price_range['upper_limit']!=undefined){
    if(query!=''){
      query +=' AND variants.price:<='+ price_range['upper_limit'];
    } else {
      query =' variants.price:<='+ price_range['upper_limit'];
    }
  }
  console.log('qry-'+query);
   var mutation = `
  {
	  products(query: "`+query+`", first: 250) {
	    edges {
	      node {
	        handle
	        id
	        title
	        descriptionHtml
	        productType
	        onlineStoreUrl
	        vendor
	        images(first: 10) {
	          edges {
	            node {
	              src
	              id
	            }
	          }
	        }
	        variants(first: 50) {
	          edges {
	            node {
	            	 id
	                 title
	                 price
	                 weight
	                 availableForSale
	                 weightUnit
	                 compareAtPrice
	            }
	          }
	        }
	      }
	    }
	  }
	}
    `;
  
  
var settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://am-vitamins-products.myshopify.com/api/2019-10/graphql.json',
    'method': 'POST',
    'headers': {
        'X-Shopify-Storefront-Access-Token': '3792eafaa6e18e1bc5fe741d49b79d7f',
        'Content-Type': 'application/graphql',
    },
    'data': mutation
};
  $.ajax(settings).done(function (response) {
    console.log(response);
    var data = [];
    $.each(response.data.products.edges, function (i, item) {
        //console.log(item.node.images.edges);
       var variants = [];
       $.each(item.node.variants.edges, function(a, vari){
   	    variants.push({'variant_id':vari.node.id,'price':vari.node.price,'weight':vari.node.weight,'weight_unit':vari.node.weightUnit,'is_available':vari.node.availableForSale,'compare_at_price':vari.node.compareAtPrice});
           }); 
        var img=[];
       $.each(item.node.images.edges, function(a, vari){
           //console.log(vari.node);
           img.push(vari.node);
           
    	//   img.push({'id':vari.node.id,'src':vari.node.src});
             });  
      data.push({"id":item.node.id,"title":item.node.title,"handle":item.node.handle,"productType":item.node.productType,"vendor":item.node.vendor,"url":item.node.onlineStoreUrl,"desc":item.node.descriptionHtml,"images":img,"variants":variants}); 
       //console.log(data);
    });
    query='';
    product_data.products=data;
    buildFilteredProducts(product_data,page,true);
    //buildFilteredProducts(product_data);
  });
    /*
  //get total products 
    $.ajax({
        type: 'GET',
       // url: '/products.json?query='+key+':'+value+'limit=250&page=1',
      	url:'https://fd463bb0c679cc78e5f7023847129f11:456aea167b0c8f45697aa254fc8ef6d9@am-vitamins-products.myshopify.com/admin/api/2019-10/products/search.json?query='+key+':'+value+'&limit=250',
        dataType: 'json',
        success: function(res){
            console.log(res);
          initial_product_data = res;
          product_data=res;
          //var data = filterProducts(res.products,key, value);
          //console.log(data);
          buildFilteredProducts(res);
//console.log(data);
        },
        error: function(status){
             alert(status);
        }
    })
    */
  }
}


function filterProducts(products, key, value) {
  console.log(key);
    console.log(value);
    var filteredProducts = products.filter(function(product){
     // console.log(product[key]);
         return product[key].indexOf(value) > -1;
    });
  return filteredProducts;
}

function buildFilteredProducts(filteredProds,page,reload) {
//  console.log(product_data);
		console.log(filteredProds);	 
    var $productContainer = $('#js-product-container');
  
  
  if(filteredProds.products.length<1){
    console.log(filteredProds.products.length);
    $productContainer.html("<h4>We can't find product based on your refinment criteria, please try to change filters</h4>");
    var $paginationContainer = $('#product-pagination');
       $paginationContainer.empty();
    $("#product-counter").html('');
    return false;
  }
			  
  current_page = page;
        
        var products = [],
        product = {}, 
        products = filteredProds.products.map(function(productItem) {
          var src = (productItem.images[0])?productItem.images[0].src:'';
                    var src1 = (productItem.images[1])?productItem.images[1].src:'';
         return product = {
            id: productItem.id, 
           	handle:productItem.handle,
            description: productItem.desc.replace(/<\/?[^>]+(>|$)/g, "").split(' ').join(' '), 
            title: productItem.title, 
            price: Shopify.formatMoney(productItem.variants[0].price, null),
            raw_price: productItem.variants[0].price,
            compare_price: productItem.variants[0].compare_at_price,
            compare_price_currency: Shopify.formatMoney(productItem.variants[0].compare_at_price, null),
            qty: productItem.variants[0].is_available,  
            variant_id: productItem.variants[0].variant_id,
            image_link: src,
            image_link1: src1,
        }
    });
			  
//    for pagination
  var recPerPage = per_page_count;
    // Use Math.max to ensure that we at least start from record 0
  var total_products = products.length;
  total_pages = Math.ceil((total_products/recPerPage));
    var startRec = Math.max(page - 1, 0) * recPerPage;
  
   var endRec = startRec + recPerPage;
  
  //total products 
  console.log(total_products);
  
    var recordsToShow = products.splice(startRec, endRec);
  
         var html=$('#productTemplate').tmpl(recordsToShow);
        // console.log(products);
         //console.log(template(data));
  //set product counter
  endRec =(total_products<=endRec)?total_products:endRec;
 // startRec = (startRec<1)?1:startRec;
  $("#product-counter").html('Item(s) '+(startRec+1)+' to '+endRec+' of '+total_products+' total');
  
  
  //set pagination
  //if(reload==true){
  var pagination_html='<div class="pagination_group"><ul class="pagination pagination-collection"><li class="prev">';
  if(current_page==1){
    pagination_html+='<a class="disabled pagination_link pre_link" href="javascript:;" data-page="1"><i class="cs-icon icon-arrow-left"></i></a></li>';
  } else {
    pagination_html+='<a class="pagination_link pre_link" href="javascript:;" data-page="'+(current_page-1)+'"><i class="cs-icon icon-arrow-left"></i></a></li>';
  }
  
  //pages 
  for(p=1;p<=total_pages;p++){
    if(p==current_page){
      pagination_html+='<li class="active"><a class="active pagination_link" href="javascript:;" data-page="'+p+'">'+p+'</a></li>';
    } else {
      pagination_html+='<li><a href="javascript:;" class="pagination_link" data-page="'+p+'">'+p+'</a></li>';
    }
  }
  
  if(current_page==total_pages){
    pagination_html+='<li class="prev"><a class="disabled pagination_link next_link" href="javascript:;"><i class="cs-icon icon-arrow-right"></i></a></li>';
  } else {
    pagination_html+='<li class="next"><a class="pagination_link next_link" href=javascript:;" data-page="'+(current_page+1)+'"><i class="cs-icon icon-arrow-right"></i></a></li>';
  }
  
  pagination_html+='</ul></div>';
  
  var $paginationContainer = $('#product-pagination');
      
       $paginationContainer.empty();
  
  $paginationContainer.html(pagination_html);
    paginationCollection();
  
 // }
//set products
  $productContainer.empty();

    $productContainer.append(html); 
  
  
  if($(window).innerWidth() > 767 ){
        
          $('.add-to-cart').bind( 'click', addToCart );
        
      }
      else { $('.add-to-cart').bind( 'click', directAddToCart ); }
      $('.cart-form .clearAllCart').bind( 'click', clearAllCart );
}


function loadSkeleton(){
 $('skeleton').each(function(){
	var type = $(this).attr('type');
	var style = ($(this).attr('element-style'))?$(this).attr('element-style'):'dark';
	var content="";
	switch(type){
	case 'heading':
		var align = ($(this).attr('align'))?$(this).attr('align'):'left';
		var size = ($(this).attr('size'))?$(this).attr('size'):'100%';
		content ='<span class="skeleton-heading '+style+' '+align+'" style="width:'+size+'"></span>';
		break;
	case 'paragraph':
		var count = ($(this).attr('count'))?$(this).attr('count'):1;
		var size = ($(this).attr('size'))?$(this).attr('size'):'100%';
		content ='<ul class="skeleton-para '+style+'" style="width:'+size+'">';
		for(i=1;i<=count;i++){
			content +='<li></li>';
		}
		content +='</ul>';
		break;
	case 'line':
		var size = ($(this).attr('size'))?$(this).attr('size'):'100%';
		var align = ($(this).attr('align'))?$(this).attr('align'):'left';
		content ='<span class="skeleton-line '+style+' '+align+'" style="width:'+size+'"></span>';
		break;
	case 'image':
		var width = ($(this).attr('width'))?$(this).attr('width'):'100%';
		var height = ($(this).attr('height'))?$(this).attr('height'):'100%';
		content ='<span class="skeleton-image '+style+'" style="width:'+width+';height:'+height+';"></span>';
		break;
	case 'input':
		var width = ($(this).attr('width'))?$(this).attr('width'):'100%';
		var height = ($(this).attr('height'))?$(this).attr('height'):'100%';
		content ='<span class="skeleton-input '+style+'" style="width:'+width+';height:'+height+';"></span>';
		break;
	case 'round-image':
		var width = ($(this).attr('width'))?$(this).attr('width'):'100%';
		var height = ($(this).attr('height'))?$(this).attr('height'):'100%';
		content ='<span class="skeleton-image-round '+style+'" style="width:'+width+';height:'+height+';"></span>';
		break;
	}
	$(this).html(content);
}); 
}



$(function(){
  
  //load page 
  $('.clear-filter-link').on('click',function(e){
  		e.preventDefault();
    console.log(vendor);
    var is_filtered=false;
    if(vendor.length>0 || type.length>0 || price_range.length>0){
      is_filtered=true;
    }
    	var filter_name = $(this).data('name');
    $("[data-filter='" + filter_name +"']").parent().removeClass("active");
    console.log(filter_name.toLowerCase());
    if(filter_name.toLowerCase()=="brands"){
      vendor.length=0;
    } else if(filter_name.toLowerCase()=="form"){
      type.length=0;
    } else {
      price_range.length=0;
    }
    console.log(vendor.length);
        console.log(type.length);
        console.log(price_range.length);
    query='';
    if(vendor.length==0 && type.length==0 && price_range.length==0 && is_filtered==true){
      console.log('reload');
     // location.reload();
    } else {
      getFilterProducts(1,true);
    }
    console.log('in function '+query);

  });
  

    $('.filter-block .filter-content li > a').on('click', function(e){
      e.preventDefault();

      //set loader skeleton
      var page_skeleton_html="";
      for (a=0;a<per_page_count;a++){
       page_skeleton_html+=skeleton_html; 
      }
      
          var $productContainer = $('#js-product-container');
      
       $productContainer.empty();

    $productContainer.append(page_skeleton_html);
        loadSkeleton();
      
//      empty pagination
       var $paginationContainer = $('#product-pagination');
      
       $paginationContainer.empty();
      
      
      $(this).parent().toggleClass('active');
        var key = $(this).data('key');
        var value = $(this).data('handle');
     // console.log(key);
      //console.log(value);
      
      if(key=="vendor"){
        var idx = $.inArray(value, vendor);
        if (idx == -1) {
  			vendor.push(value);
		} else {
  			vendor.splice(idx, 1);
		}
      } else if(key=="type"){
        var idx = $.inArray(value, type);
        if (idx == -1) {
  			type.push(value);
		} else {
  			type.splice(idx, 1);
		}
        
      } else if(key=="price_range"){
        //console.log(value.toLowerCase().indexOf('under'));
        if(value.toLowerCase().indexOf('under')>-1){
          price_range['lower_limit']=0;
          price_range ['upper_limit']=value.toLowerCase().replace('under $','');
        } else if(value.toLowerCase().indexOf('above') >-1){
         price_range['upper_limit']=''; 
        } else {
          var range_array = value.split('-');
          console.log(parseInt(price_range['lower_limit']));
                    console.log(parseInt(price_range['upper_limit']));
          var lower = range_array[0].replace('$','');
          var upper = range_array[1].replace('$','');
          if(price_range['lower_limit']!='' || parseInt(lower)<parseInt(price_range['lower_limit'])){
           price_range['lower_limit']=parseInt(lower); 
          }
          if(price_range['upper_limit']!='' || parseInt(upper)>parseInt(price_range['upper_limit'])){
           price_range['upper_limit']=parseInt(upper); 
          }
        }
      }
      console.log(price_range);
      //console.log(vendor);
       getFilterProducts(1,true);
    });

});

/* slider product*/
function sliderProduct(){
  /* Slider Relatedpro */
  if($(".related-products-full .rp-slider").length){
    $(".related-products-full .rp-slider").owlCarousel({
      navigation : true,
      pagination: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1920,4],
      itemsDesktopSmall : [1200,4],
      itemsTablet: [1199,4],
      itemsTabletSmall: [991,3],
      itemsMobile : [767,2]
    });
  } 
  /* Slider Thumb */
  if($(".thumbs-mobile .slider-3itemsc").length){
    $(".thumbs-mobile .slider-3itemsc").owlCarousel({
      navigation : true,
      pagination: false,
      autoPlay: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [991,4],
      itemsTablet: [767,4],
      itemsTabletSmall: [540,4],
      itemsMobile : [420,4]
    });
  }
  $(".show-load-detail").css("display", "none");
}
/* slider product*/
function sliderBlog(){
  if($(".related-blog-slider").length){
    $(".related-blog-slider").owlCarousel({
      navigation : true,
      pagination: false,
      autoPlay: false,
      items: 3,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [991,1],
      itemsTablet: [767,1],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1]
    });
  }
}

/* Handle dropdown box */
function handleDropdown(){
  var changeIcon = function() {
    $( ".dropdownMobile-toggle" ).each(function( index ) {
      $(this).parent().find('.dropdown-menu').hide();
      $(this).removeClass('active-dropdown');
      var icon_class=$(this).find('.icon-dropdown').data('class');
      $(this).find('.icon-dropdown').attr('class','icon-dropdown '+icon_class);
    });
  }
  var dropdownDesktop = function() {
    if($('.dropdown-toggle').length){
      $('.dropdown-toggle').parent().hover(function (){
        if(touch == false && getWidthBrowser() > 767 ){
          $(this).find('.dropdown-menu').stop(true, true).slideDown(300);
        }
      }, function (){
        if(touch == false && getWidthBrowser() > 767 ){
          $(this).find('.dropdown-menu').hide();
        }
      });
    }
  }
  var dropdownTablet = function(){
    if($('.dropdownMobile-toggle').length){
      $('.dropdownMobile-toggle').on('click', function() {
        if(!$(this).hasClass('active-dropdown')){
          changeIcon();
          $('body').addClass('active-overflow');
          $(this).parent().find('.dropdown-menu').stop(true, true).slideDown(300);
          $(this).addClass('active-dropdown');
          $(this).find('.icon-dropdown').attr('class','icon-dropdown cs-icon icon-close');
        }
        else{
          $('body').removeClass('active-overflow');
          changeIcon();
        }
      });
    }
  }
  $('nav .dropdown-menu').each(function(){
    $(this).find('li').last().addClass('last');
  });
  $('.dropdown').on('click', function() {
    if(touch == false && getWidthBrowser() > 767 ){
      var href = $(this).find('.dropdown-link').attr('href');
      window.location = href;
    }
  });
  $('.dropdown-1 .dropdown-link').on('click', function() {
    if(touch == false && getWidthBrowser() > 767 ){
      var href = $(this).attr('href');
      window.location = href;
    }
  });
  dropdownDesktop();
  dropdownTablet();
}

/* Fucntion get width browser */
function getWidthBrowser() {
  var myWidth;

  if( typeof( window.innerWidth ) == 'number' ) { 
    //Non-IE 
    myWidth = window.innerWidth;
    //myHeight = window.innerHeight; 
  } 
  else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
    //IE 6+ in 'standards compliant mode' 
    myWidth = document.documentElement.clientWidth; 
    //myHeight = document.documentElement.clientHeight; 
  } 
  else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
    //IE 4 compatible 
    myWidth = document.body.clientWidth; 
    //myHeight = document.body.clientHeight; 
  }

  return myWidth;
}

// handle scroll-to-top button
function handleScrollTop() {
  function totop_button(a) {
    var b = $("#scroll-to-top"),
        f = $(".cart-float-right");

    if (a == "on") { 
      f.addClass("on fadeInRight ").removeClass("off fadeOutRight");
      b.addClass("on fadeInRight ").removeClass("off fadeOutRight"); 
    } else {
      f.addClass("off fadeOutRight animated").removeClass("on fadeInRight");
      b.addClass("off fadeOutRight animated").removeClass("on fadeInRight"); 
    }
  }
  $(window).scroll(function() {
    var b = $(this).scrollTop();
    var c = $(this).height();
    if (b > 0) { 
      var d = b + c / 2;
    } 
    else { 
      var d = 1 ;
    }    
    if (d < 1e3 && d < c) { 
      totop_button("off");
    } 
    else {
      totop_button("on"); 
    }
  });  
  $("#scroll-to-top").click(function (e) {
    e.preventDefault();
    $('body,html').animate({scrollTop:0},800,'swing');
  });
}   

//newsletter popup
function ModalNewsletter(){
  var showNewsletter = function(date){
    $('#newsletter-popup').modal('toggle');
    $('.nl-wraper-popup').addClass('animated'); 
    var tnout = 20 ;
    setTimeout (function() { 
      $('#newsletter-popup').modal('hide');
    }, tnout*1000 );
    localStorage.setItem('cs-newsletter', date );
  }
  var checkNewsletter = function(){
    var date = '06/24/2022 18:50:19';
    if(localStorage.getItem('cs-newsletter') == null || localStorage.getItem('cs-newsletter') == "undefined" ){
	  showNewsletter(date);
    }
    else{
      var check_time = new Date(date) - new Date(localStorage.getItem('cs-newsletter'));
      var ms = check_time % 1000;
      check_time = (check_time - ms) / 1000;
      var days = Math.floor(check_time / 86400);
      if(days > 7){
        showNewsletter(date);
      }
    }
  }
  
  checkNewsletter();
  
}

/* Handle product quantity */
function handleQuantity(){
  if($('.quantity-wrapper').length){
    $('.quantity-wrapper').on(clickEv, '.qty-up', function() {
      var $this = $(this);
      var qty = $this.parents('.wrapper').find('input');
      $(qty).val(parseInt($(qty).val()) + 1);
    });
    $('.quantity-wrapper').on(clickEv, '.qty-down', function() {
      var $this = $(this);
      var qty = $this.parents('.wrapper').find('input');
      if(parseInt($(qty).val()) > 1)
        $(qty).val(parseInt($(qty).val()) - 1);
    });
  }
}

function colorwarches(){
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  }); 
}

function toggleTagsFilter(){ 
  if(window.innerWidth >= 768 ){
    var tagsbutton = document.getElementById( 'showTagsFilter' ),    
        tagscontent = document.getElementById( 'tags-filter-content' );    
    if(tagsbutton != null ){
      tagsbutton.onclick = function() {
        classie.toggle( this, 'closed' );
        classie.toggle( tagscontent, 'tags-closed' );
        if(classie.has( this, 'closed' ))
          $('#showTagsFilter').html("Filter <i class='fa fa-angle-down'></i>");
        else $('#showTagsFilter').html("Filter <i class='fa fa-angle-up'></i>");
      };
    }
  }
}

/* Function update scroll product thumbs */
function updateScrollThumbsQS(){
  if($('#gallery_main_qs').length){

    $('#quick-shop-image .fancybox').on(clickEv, function() {
      var _items = [];
      var _index = 0;
      var product_images = $('#gallery_main_qs .image-thumb a');
      product_images.each(function(key, val) {
        _items.push({'href' : val.href, 'title' : val.title});
        if($(this).hasClass('active')){
          _index = key;
        }
      });
      $.fancybox(_items,{
        closeBtn: true,
        index: _index,
        helpers: {
          buttons: {}
        }
      });
      return false;
    });

    $('#quick-shop-image').on(clickEv, '.image-thumb a', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');

      background.show();

      parent.find('.image-thumb').removeClass('active');
      $this.parent().addClass('active');

      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });

      return false;
    });
  }
}

//Change Quantity Quick Show
function change_qs_quantity(qs){
  qs_quantity=qs;
}

function showMenuMobile(){
  var changeIcon = function(){
    $('.navigation_mobile .arrow').removeClass('class_test');
    $('.navigation_mobile .arrow i').attr('class', 'cs-icon icon-ios-plus-empty');
    $('.navigation_mobile').removeClass('active_dropdown');
    $('.navigation_mobile .menu-mobile-container').hide("fast");
  }
  var showMenu = function(){
    $('.group_navbtn_action .dropdown-toggle-navigation').on('click', function() {
      $(this).addClass('active-dropdown');
      $(this).parent().find('.navigation_dropdown_scroll').addClass("hover-dropdown");
      $('#top').attr("id","top-activeRight");
    });
  }
  var closeMenu = function(){
    $('.group_navbtn_action .close-navigation-dropdown').on('click', function() {
      $(this).parents('.navigation_dropdown_scroll').removeClass("hover-dropdown");
      $('#top-activeRight').attr("id","top");
    });
    $('.group_navbtn_action .navigation_dropdown_scroll_close').on('click', function() {
      $(this).parents('.navigation_dropdown_scroll').removeClass("hover-dropdown");
      $('#top-activeRight').attr("id","top");
    });
  }
  var showMegaMenu = function(){
    $('.navigation_mobile .arrow').on('click', function() {
      if($(this).hasClass('class_test')){
        $(this).removeClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-plus-empty');
        $(this).parent().removeClass('active_dropdown');
        $(this).parent().find('.menu-mobile-container').hide("fast");
      }
      else{
        changeIcon();
        $(this).addClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-minus-empty');
        $(this).parent().addClass('active_dropdown');
        $(this).parent().find('.menu-mobile-container').show("fast");
      }
    });
  }
  var showSubMenu = function(){
    $('.navigation_sub_mobile .arrow_sub_mobile').click(function(){
      if($(this).hasClass('class_test')){
        $(this).removeClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-plus-empty');
        $(this).parent().removeClass('active_dropdown');
        $(this).parent().find('.sub-menu-mobile-container').hide("fast");
      }
      else{
        $(this).addClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-minus-empty');
        $(this).parent().addClass('active_dropdown');
        $(this).parent().find('.sub-menu-mobile-container').first().show("fast");
      }
    });
  }
  var showShowInfo = function(){
    $('.icon_info .show-info').on('click', function() {
      var classShow = $(this).data('class');
      $('#top').find('.'+classShow).addClass('active-show');
      $('#top .info-header').addClass('active');
      $('#top').attr("id","top-activeRight");
    });
    $('.info-header .close-info').on('click', function() {
      $('#top-activeRight').attr("id","top");
      $('.info-header .info-header-item').removeClass('active-show');
      $('#top .info-header').removeClass('active');
    });
    $('.info-header .info-header-close').on('click', function() {
      $('#top-activeRight').attr("id","top");
      $('.info-header .info-header-item').removeClass('active-show');
      $('#top .info-header').removeClass('active');
    });
  }
  showMenu();
  closeMenu();
  showMegaMenu();
  showSubMenu();
  showShowInfo();
}

function showItemMobile(){
  $('.item-dropdown-mobile .btn-group').on('click', '.dropdown-toggle', function() {
    $('.item-dropdown-mobile .dropdown-menu').css('display','none');

    if($(this).hasClass('active_popup')){
      $(this).removeClass('active_popup');
    }
    else{
      $('.item-dropdown-mobile .dropdown-toggle').removeClass('active_popup');
      $(this).addClass('active_popup');
      $('.item-dropdown-mobile').each(function(){
        if($(this).find('.dropdown-toggle').hasClass('active_popup')){
          $(this).find('.dropdown-menu').css('display','block');
        }
      });
    }
  });
}

function showPassword(){
  $(".form-password .cs-icon").on(clickEv, function() {
    if($(this).hasClass("show-pass")){
      $(this).parent().find("input").attr('type','password');
      $(this).removeClass("show-pass");
    }
    else{
      $(this).parent().find("input").attr('type','text');
      $(this).addClass("show-pass");
    }
  });
}

function sidebarBlog(){
  $(".sidebar-block .sidebar-title").on(clickEv, '.cs-icon', function() {
    if($(this).hasClass("show-content")){
      $(this).parents('.sidebar-block').find(".sidebar-content").show( "slow" );
      $(this).attr('class','cs-icon icon-ios-minus-empty');
    }
    else{
      $(this).parents('.sidebar-block').find(".sidebar-content").hide( "slow" );
      $(this).attr('class','show-content cs-icon icon-ios-plus-empty');
    }
  });
}
var createUrl = function(url,queryParams){
    history.pushState({
      param: queryParams
    }, url, url);
    $.ajax({
      type: 'GET',
      url: url,
      data: {},
      beforeSend: function( xhr ) {
        $("#tags-load").show();
      },
      complete: function (data) {  
        $('#collection').html($("#collection", data.responseText).html());      
        $("#tags-load").hide();
        var urls = "\/\/productreviews.shopifycdn.com\/assets\/v4\/spr.js?shop=";
        $.getScript(urls, function() {
        });
        handleGridList();
        toggleTagsFilter();
        $(GLOBAL['common']['init']);
        filterClick();
        sidebarBlog();
        clearFilterMobile();
        clearFilterFullwidth();
        applyFilterMobile();
        paginationCollection();
        setupPagination();
        showFilter();
        if(checkCollection == 1){
          removeFilter();
        }
        handleDropdown();
        collectionTopFilter();
      }
    });
  }
  var filterClick = function(){
    $('.filter-block .filter-content li > a > a').click(function(event) {
      event.preventDefault();
      var newTags = [];
      if (Shopify.queryParams.constraint) {
        newTags = Shopify.queryParams.constraint.split('+');
      }
      var dataHandle = $(this).parents('li').data("handle");
      if (dataHandle) {
        var tagCheck = newTags.indexOf(dataHandle);
        if (tagCheck >= 0) {
          newTags.splice(tagCheck, 1);
        } else {
          newTags.push(dataHandle);
        }
      }
      if (newTags.length) {
        Shopify.queryParams.constraint = newTags.join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }
      delete Shopify.queryParams.page;
      newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');

      if(getWidthBrowser() > 991 ){
        var url = location.pathname + "?" + newQuery;
        createUrl(url,Shopify.queryParams);
      }
      else{
        if($(this).parents('li').hasClass('active')){
          $(this).parents('li').removeClass('active');
        }
        else{
          $(this).parents('li').addClass('active');
        }
      }
    });
  }
  var clearFilterMobile = function(){
    $('.collection-leftsidebar .sidebarMobile-clear').on(clickEv, function() {
      var url = location.pathname ;
      createUrl(url,url);
      $('#collection .collection-leftsidebar').removeClass('active');
      $('body').removeClass('active-sidebar');
    });
  }
  var clearFilterFullwidth = function(){
    $('.topCollections-clear .icon-clear').on(clickEv, function() {
      var url = location.pathname ;
      createUrl(url,url);
    });
  }
  var applyFilterMobile = function(){
    $('.sidebar-bottom .sidebarMobile-close').on(clickEv, function() {
      var url = location.pathname + "?" + newQuery;
      createUrl(url,Shopify.queryParam);
      $('.collection-leftsidebar').removeClass('active');
      $('body').removeClass('active-sidebar');
    });
  }
  
   var paginationCollection = function(){
    $('.pagination-collection li a').on(clickEv, function(event) {
      event.preventDefault();
    if($(this).hasClass('pagination_link')){
      var page_to_load=$(this).data('page');
    console.log('new page - '+page_to_load);
    console.log('current page - '+ current_page);
    if(page_to_load!==current_page){
    //for first page
    if(page_to_load==1){
      $('.prev_link').addClass('disabled');
    } else {
      $('.prev_link').removeClass('disabled');
    }
    
    //for last page 
    if(page_to_load==total_pages){
      $('.next_link').addClass('disabled');
    } else {
      $('.next_link').removeClass('disabled');
    }
      
      $(this).parent().siblings().removeClass('active');
      $(this).parent().addClass('active');
      
      getFilterProducts(page_to_load,false);
      $('body,html').animate({scrollTop:0},1,'swing');
    }
      
    } else {
   		var linkPage = $(this).attr("href").match(/page=\d+/g);
      if (linkPage) {
        Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
        if (Shopify.queryParams.page) {
          newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');
		  var url = location.pathname + "?" + newQuery;
          createUrl(url,Shopify.queryParam);
          $('body,html').animate({scrollTop:0},1,'swing');
        }
      }

    }
    });
  }
function tagFilterCollection(){
  var newQuery = '';
  var init = function(){
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }
  var createUrl = function(url,queryParams){
    history.pushState({
      param: queryParams
    }, url, url);
    $.ajax({
      type: 'GET',
      url: url,
      data: {},
      beforeSend: function( xhr ) {
        $("#tags-load").show();
      },
      complete: function (data) {  
        $('#collection').html($("#collection", data.responseText).html());      
        $("#tags-load").hide();
        var urls = "\/\/productreviews.shopifycdn.com\/assets\/v4\/spr.js?shop=";
        $.getScript(urls, function() {
        });
        handleGridList();
        toggleTagsFilter();
        $(GLOBAL['common']['init']);
        filterClick();
        sidebarBlog();
        clearFilterMobile();
        clearFilterFullwidth();
        applyFilterMobile();
        paginationCollection();
        setupPagination();
        showFilter();
        if(checkCollection == 1){
          removeFilter();
        }
        handleDropdown();
        collectionTopFilter();
      }
    });
  }
  var filterClick = function(){
    $('.filter-block .filter-content li > a > a').click(function(event) {
      event.preventDefault();
      var newTags = [];
      if (Shopify.queryParams.constraint) {
        newTags = Shopify.queryParams.constraint.split('+');
      }
      var dataHandle = $(this).parents('li').data("handle");
      if (dataHandle) {
        var tagCheck = newTags.indexOf(dataHandle);
        if (tagCheck >= 0) {
          newTags.splice(tagCheck, 1);
        } else {
          newTags.push(dataHandle);
        }
      }
      if (newTags.length) {
        Shopify.queryParams.constraint = newTags.join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }
      delete Shopify.queryParams.page;
      newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');

      if(getWidthBrowser() > 991 ){
        var url = location.pathname + "?" + newQuery;
        createUrl(url,Shopify.queryParams);
      }
      else{
        if($(this).parents('li').hasClass('active')){
          $(this).parents('li').removeClass('active');
        }
        else{
          $(this).parents('li').addClass('active');
        }
      }
    });
  }
  var clearFilterMobile = function(){
    $('.collection-leftsidebar .sidebarMobile-clear').on(clickEv, function() {
      var url = location.pathname ;
      createUrl(url,url);
      $('#collection .collection-leftsidebar').removeClass('active');
      $('body').removeClass('active-sidebar');
    });
  }
  var clearFilterFullwidth = function(){
    $('.topCollections-clear .icon-clear').on(clickEv, function() {
      var url = location.pathname ;
      createUrl(url,url);
    });
  }
  var applyFilterMobile = function(){
    $('.sidebar-bottom .sidebarMobile-close').on(clickEv, function() {
      var url = location.pathname + "?" + newQuery;
      createUrl(url,Shopify.queryParam);
      $('.collection-leftsidebar').removeClass('active');
      $('body').removeClass('active-sidebar');
    });
  }
  
   var paginationCollection = function(){
    $('.pagination-collection li a').on(clickEv, function(event) {
      event.preventDefault();
     // console.log('I am clicked');
    if($(this).hasClass('pagination_link')){
      var page_to_load=$(this).data('page');
    console.log(page_to_load);
    console.log(current_page);
    if(page_to_load!==current_page){
    //for first page
    if(page_to_load==1){
      $('.prev_link').removeClass('disabled');
    } else {
      $('.prev_link').addClass('disabled');
    }
    
    //for last page 
    if(page_to_load==total_pages){
      $('.next_link').addClass('disabled');
    } else {
      $('.next_link').removeClass('disabled');
    }
      $(this).parent().siblings().removeClass('active');
      $(this).parent().addClass('active');
      
      getFilterProducts(page_to_load,false);
    }
      
    } else {
   		var linkPage = $(this).attr("href").match(/page=\d+/g);
      if (linkPage) {
        Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
        if (Shopify.queryParams.page) {
          newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');
		  var url = location.pathname + "?" + newQuery;
          createUrl(url,Shopify.queryParam);
          $('body,html').animate({scrollTop:0},1,'swing');
        }
      }

    }
    });
  }
  
  var removeFilter = function(){
    $('.collection-leftsidebar').removeClass('active');
    $('body').removeClass('active-sidebar');
  }
  var activeFilter = function(){
    $('.collection-leftsidebar').addClass('active');
    $('body').addClass('active-sidebar');
  }
  var showFilter = function(){
    $('.show-leftsidebar').on(clickEv, function() {
      if($('.collection-leftsidebar').hasClass('active')){
        removeFilter();
      }
      else{
        activeFilter();
      }
    });
    $('.close-leftsidebar').on(clickEv, function() {
      removeFilter();
    });
  }
  var collectionTopFilter = function(){
    $(".topCollections-title").on(clickEv, function() {
      var content = $(this).parents('.topCollections-block');
      if(content.hasClass('active-popup')){
        content.removeClass('active-popup');
        content.find('.topCollections-content').hide("normal");
      }
      else{
        $('.topCollections-block').removeClass('active-popup');
        $('.topCollections-content').hide("normal");
        content.addClass('active-popup');
        content.find('.topCollections-content').show("normal");
      }
    });
  }
  
  init();
  if(checkCollection != 0){
  filterClick();
  }
  clearFilterMobile();
  clearFilterFullwidth();
  applyFilterMobile();
  paginationCollection();
  //setupPagination();
  showFilter();
  collectionTopFilter();
}

function handleAnimate(){
    
    $('[data-animate]').each(function(){
      
      var $toAnimateElement = $(this);
      
      var toAnimateDelay = $(this).attr('data-delay');
      
      var toAnimateDelayTime = 0;
      
      if( toAnimateDelay ) { toAnimateDelayTime = Number( toAnimateDelay ); } else { toAnimateDelayTime = 200; }
      
      if( !$toAnimateElement.hasClass('animated') ) {
        
        $toAnimateElement.addClass('not-animated');
        
        var elementAnimation = $toAnimateElement.attr('data-animate');
        
        $toAnimateElement.appear(function () {
          setTimeout(function() {
            $toAnimateElement.removeClass('not-animated').addClass( elementAnimation + ' animated');
          }, toAnimateDelayTime);
          
        },{accX: 0, accY: -50},'easeInCubic');
        
      }
    });
}

function handleScrollDown() {
  $(".carousel-scroll-button").click(function() {
    $('html, body').animate({scrollTop: $(this).offset().top + 40}, 1000);
    return false;
  });
}

function mapSection(){
  var init = function(){
    if($('[data-map-section]').length){
      $('[data-map-section]').each(function() {
        if($(this).data('position-lat') != '' || $(this).data('position-lng') != ''){
          var position = {lat: $(this).data('position-lat'), lng: $(this).data('position-lng')};
		  initMap(position, $(this).data('zoom'), $(this).data('address'), $(this).attr('id'));
        }
      });
    }
  }
  var initMap = function(position, zoom, address, id) {
    var styledMapType = new google.maps.StyledMapType(
      [
        {
          "featureType": "all",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "weight": "2.00"
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#9c9c9c"
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#f2f2f2"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "landscape.man_made",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": 45
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#f1f0ef"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#7b7b7b"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#edf7fb"
            },
            {
              "visibility": "on"
            }
          ]
        }
      ],
      {name: 'Styled Map'}
    );
    var mapCS = new google.maps.Map(document.getElementById(id), {
      zoom: zoom,
      center: position
    });
    var infowindow = new google.maps.InfoWindow({
      content: address
    });
    var marker = new google.maps.Marker({
      position: {lat: 40.7852705, lng: -74.6508684},
      icon: '//cdn.shopify.com/s/files/1/0284/1103/5747/t/2/assets/marker-map.png?v=4577854602838272631572067338',
      map: mapCS,
      title: address
    });
    marker.addListener('click', function() {
      infowindow.open(mapCS, marker);
    });
    //Associate the styled map with the MapTypeId and set it to display.
    mapCS.mapTypes.set('styled_map', styledMapType);
    mapCS.setMapTypeId('styled_map');
  }
  init();
}

$(window).ready(function($) {
  
  handleDropdown();
  
  
    if(touch == false && getWidthBrowser() > 992 ){
      handleAnimate(); 
    }
    else{
      $('.not-animated').css("opacity","1");
    }
  
  
  mapSection();
  
  handleScrollDown();
  
  tagFilterCollection();
  
  sidebarBlog();
  
  showPassword();
  
  showItemMobile();

  sliderProduct();
  
  sliderBlog();

  handleScrollTop();

  colorwarches();

  $('[data-toggle="tooltip"]').tooltip();

  handleQuantity();

  toggleTagsFilter();

  updateScrollThumbsQS();

  showMenuMobile();
});


$(window).load(function() { 
  
  

  ModalNewsletter();
  
});
